import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import * as schoolRollActions from '../school-roll/actions';
import { showToast } from '../../components/toast/actions';
import { validateStudentDeletion } from '../../helpers/utils';

export function* getStudents({ productId, classrooms }) {
    const payload = yield call(api.getStudentsByProduct, productId);
    if (payload.status === 200) {
        yield put(actions.getProductStudentsSuccess(payload.data, classrooms));
    } else {
        yield put(actions.getProductStudentsFailure());
    }
}

export function* downloadStudentRoll(students) {
    const response = yield call(api.postStudentsPriorDownload, students);
    if (response.status === 201) {
        const downloadUrl = response.verb.url + response.data;
        yield put(actions.downloadStudentRollSuccess(downloadUrl, true));
    } else {
        yield put(actions.downloadStudentRollFailure());
    }
}

export function* addStudent({ student }) {
    const response = yield call(api.addStudent, student);
    if (response.status === 200) {
        yield put(actions.addStudentSuccess(response.data.userProfileId));
    } else if (response.status === 400 || response.status === 409) {
        yield put(actions.addStudentFailure(false, response.message, false));
        yield put(showToast(response.message, 'error'));
    } else {
        yield put(actions.addStudentFailure(true, ''));
    }
}

export function* getStudentsSaga() {
    yield takeLatest(actions.GET_PRODUCT_STUDENTS_REQUEST, getStudents);
}

export function* downloadStudentRollSaga() {
    yield takeEvery(actions.DOWNLOAD_STUDENT_ROLL_REQUEST, downloadStudentRoll);
}

export function* unassignStudents({ selectedStudents, productId }) {
    const userRelationship = { productId, studentsProfileIdToUnassign: selectedStudents };
    const response = yield call(api.unAssignStudents, userRelationship);
    if (response.status === 200) {
        yield put(actions.unassignStudentsSuccess());
    } else {
        yield put(actions.unassignStudentsFailure());
    }
}

export function* unassignStudentsSaga() {
    yield takeLatest(actions.UNASSIGN_STUDENTS_REQUEST, unassignStudents);
}

export function* downloadStudentSignInCards({ productId, studentSignInCardsData }) {
    const response = yield call(api.downloadStudentsSignInCards, productId, studentSignInCardsData);
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.printSignInCardSuccess(downloadUrl, true));
    } else {
        yield put(actions.printSignInCardFailure(true));
    }
}

export function* downloadSignInCardSaga() {
    yield takeLatest(actions.PRINT_SIGN_IN_CARD_REQUEST, downloadStudentSignInCards);
}

export function* addStudentSaga() {
    yield takeLatest(actions.ADD_STUDENT_REQUEST, addStudent);
}

export function* deleteStudent({ userProfileIds, productId }) {
    const userRelationship = { userProfileIds };
    const response = yield call(api.deleteStudents, userRelationship);
    if (response.status === 200) {
        const result = validateStudentDeletion(response.data);
        yield put(actions.deleteStudentSuccess(result));
        yield put(schoolRollActions.getLicenceCapSummary(productId));
    } else {
        yield put(actions.deleteStudentFailure());
    }
}

export function* deleteStudentSaga() {
    yield takeLatest(actions.DELETE_STUDENT_REQUEST, deleteStudent);
}

/**
 * @param selectedStudents
 * @param newPassword
 */
export function* bulkPasswordChangeStudents({ selectedStudents, newPassword }) {
    const changePassword = { UserProfileIds: selectedStudents, NewPassword: newPassword };
    const response = yield call(api.bulkPasswordChangeStudents, changePassword);
    if (response.status === 200) {
        yield put(actions.bulkPasswordChangeStudentsSuccess());
    } else {
        yield put(actions.bulkPasswordChangeStudentsFailure());
    }
}

export function* bulkPasswordChangeStudentsSaga() {
    yield takeLatest(actions.BULK_PASSWORD_CHANGE_STUDENTS_REQUEST, bulkPasswordChangeStudents);
}

export function* getClassroomGroups({ classroomId }) {
    const state = yield select();
    const emptyListValue = '-1';
    if (classroomId === emptyListValue) {
        state.studentRoll.classroomGroups = [];
        return;
    }
    const payload = yield call(api.getClassroomGroups, classroomId);
    if (payload.status === 200) {
        const { studentModel } = state.studentRoll;
        if (payload.data.length === 1) {
            studentModel.classroomGroupId = String(payload.data[0].id);
        } else {
            studentModel.classroomGroupId = emptyListValue;
        }

        yield put(actions.getClassroomGroupsSuccess(payload.data));
    } else {
        yield put(actions.getClassroomGroupsFailure());
    }
}

export function* getClassroomGroupsSaga() {
    yield takeLatest(actions.ADD_STUDENT_GET_GROUPS_REQUEST, getClassroomGroups);
}



// WEBPACK FOOTER //
// ./app/containers/student-roll/saga.js